import request from '@/utils/request'
const BASE_URL = '/ali/logistic'

export default {
  sync() {
    return request({
      url: BASE_URL + '/sync',
      method: 'post',
    })
  },
  syncStatus() {
    return request({
      url: BASE_URL + '/syncstatus',
      method: 'get',
    })
  },
  getLogistics() {
    return request({
      url: BASE_URL,
      method: 'get',
    })
  },
  syncAddress() {
    return request({
      url: BASE_URL + '/syncaddress',
      method: 'post',
    })
  },
  getAddress() {
    return request({
      url: BASE_URL + '/address',
      method: 'get',
    })
  },
  getSendaddress(params) {
    return request({
      url: BASE_URL + '/sendaddress',
      method: 'get',
      params
    })
  },
  postSendaddress(data) {
    return request({
      url: BASE_URL + '/sendaddress',
      method: 'post',
      data
    })
  },
  putSendaddress(data) {
    return request({
      url: BASE_URL + '/sendaddress',
      method: 'put',
      data
    })
  },
  delSendaddress(data) {
    return request({
      url: BASE_URL + '/sendaddress',
      method: 'delete',
      data
    })
  },
  setDefault(id) {
    return request({
      url: BASE_URL + '/default?id=' + id,
      method: 'put',
    })
  },
}